import React, { PropsWithChildren } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

/**
 * Gráfico em tela cheia no mobile, compartilhado entre módulos. **Retrato, sem
 * rotação** é o padrão — header com título + fechar e o gráfico ocupando o
 * resto da tela. Genérico via `children` (serve o HistoryGraph e o MJO do
 * Clima, e os gráficos do Windx), que devem preencher a altura (100%).
 *
 * `landscape` liga o padrão usado no resto do app para gráficos com dois
 * dataZoom (Flux Automatic, Meteorology Fields/Agro): sem header, botão de
 * fechar fixo e o conteúdo girado 90° para caber a tela toda — `title` é
 * ignorado nesse modo, mesma convenção das demais telas landscape.
 */
export default function FullscreenChart({
  open,
  dismiss,
  title,
  landscape,
  children,
}: PropsWithChildren<{
  open: boolean;
  dismiss: () => void;
  title?: string;
  landscape?: boolean;
}>) {
  if (!open) return null;

  if (landscape) {
    return (
      <div className="mobile-fullscreen-chart-overlay mobile-fullscreen-chart-overlay--landscape">
        <button
          type="button"
          aria-label="Sair do modo tela cheia"
          className="mobile-fullscreen-chart-close mobile-fullscreen-chart-close--landscape"
          onClick={dismiss}
        >
          <Icon iconType="close" color={cssVar('text-strong')} />
        </button>
        <div className="mobile-fullscreen-chart-rotate">
          <div className="mobile-fullscreen-chart-body mobile-fullscreen-chart-body--landscape">
            {children}
          </div>
        </div>
        <span className="mobile-fullscreen-chart-caption">
          Modo paisagem · toque no X para sair
        </span>
      </div>
    );
  }

  return (
    <div className="mobile-fullscreen-chart-overlay">
      <div className="mobile-fullscreen-chart-header">
        {title && <span className="mobile-fullscreen-chart-title">{title}</span>}
        <button
          type="button"
          aria-label="Sair do modo tela cheia"
          className="mobile-fullscreen-chart-close"
          onClick={dismiss}
        >
          <Icon iconType="close" color={cssVar('text-strong')} />
        </button>
      </div>
      <div className="mobile-fullscreen-chart-body">{children}</div>
    </div>
  );
}
